var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('StoneHeader'),_c('div',{staticClass:"order"},[(_vm.error)?_c('p',{staticClass:"h1"},[_vm._v("期限が切れたか有効なURLではありません。")]):_c('p',{staticClass:"h1"},[_vm._v("確認しています。")])]),_c('StoneFooter')],1)}
var staticRenderFns = []

export { render, staticRenderFns }